<template>
  <CoreDialog
    :value="value"
    size="md"
    title="Сортировка"
    divider
    data-qa="analyses_lpu_cards_sort_dialog"
    slot-content-class="py-0"
    @input="emit('input', $event)"
  >
    <v-radio-group
      v-model="localSort"
      class="analyses-lpu-sort-dialog__group mt-0 pt-0"
      data-qa="analyses_lpu_cards_sort_dialog_options"
      hide-details
    >
      <v-radio
        v-for="item in ANALYSES_LPU_SORT_ITEMS"
        :key="item.name"
        :value="item.value"
        :ripple="false"
        color="primary"
        class="analyses-lpu-sort-dialog__option"
        data-qa="analyses_lpu_cards_sort_option"
      >
        <template #label>
          <span class="text-body-1 text--text">
            {{ item.name }}
          </span>
        </template>
      </v-radio>
    </v-radio-group>

    <template #actions>
      <v-btn
        text
        data-qa="analyses_lpu_cards_sort_dialog_cancel"
        @click="cancel"
      >
        Отменить
      </v-btn>
      <v-btn
        text
        color="primary"
        data-qa="analyses_lpu_cards_sort_dialog_confirm"
        @click="confirm"
      >
        Сортировать
      </v-btn>
    </template>
  </CoreDialog>
</template>

<script setup lang="ts">
import {
  ref,
  watch,
} from 'vue'
import CoreDialog from 'src/core/CoreDialog/CoreDialog.vue'
import {
  ANALYSES_LPU_SORT_ITEMS,
  type AnalysesLpuSortValue,
} from 'src/components/pages/[town-translit]/diagnostika/analiz/_constants/analyses-lpu-sort'

const props = defineProps<{
  value: boolean
  selectedSort: AnalysesLpuSortValue
}>()

type Emits = {
  (_event: 'input', _value: boolean): void
  (_event: 'confirm', _value: AnalysesLpuSortValue): void
}

const emit = defineEmits<Emits>()

const localSort = ref<AnalysesLpuSortValue>(props.selectedSort)

watch(() => props.value, isOpen => {
  if (isOpen) {
    localSort.value = props.selectedSort
  }
})

function close() {
  emit('input', false)
}

function cancel() {
  close()
}

function confirm() {
  emit('confirm', localSort.value)
  close()
}
</script>

<style lang="scss" scoped>
.analyses-lpu-sort-dialog {
  &__group :deep(.v-input--radio-group__input) {
    row-gap: 16px;
  }

  &__option {
    margin-bottom: 0;
  }

  &__option :deep(.v-input--selection-controls__input) {
    margin-right: 8px;
  }
}
</style>
